import { render, staticRenderFns } from "./TaskHistoryCollapse.vue?vue&type=template&id=28710686&"
import script from "./TaskHistoryCollapse.vue?vue&type=script&lang=js&"
export * from "./TaskHistoryCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports